// Mapper for prompt-version payloads. Re-uses toVersionInfo from
// agentConfig so the common envelope stays in one place.

import { toVersionInfo } from '../../agentConfig/model/toAgentConfigView';
import type { AgentPromptVersionView } from './types';

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}

export function toAgentPromptVersion(raw: unknown): AgentPromptVersionView | null {
  if (!isRecord(raw)) return null;
  const base = toVersionInfo(raw);
  if (base === null) return null;
  const content = typeof raw.content === 'string' ? raw.content : '';
  return { ...base, content };
}

export function toAgentPromptVersionList(raw: unknown): AgentPromptVersionView[] {
  if (!isRecord(raw)) return [];
  const versions = Array.isArray(raw.versions) ? raw.versions : [];
  return versions
    .map(toAgentPromptVersion)
    .filter((v): v is AgentPromptVersionView => v !== null);
}
